import React, {useEffect, useState} from 'react';
import _ from "lodash";

function prepareTagList(tagDetailList) {
    let tempTagList = [];

    if (!_.isEmpty(tagDetailList)) {
        tempTagList = _.filter(tagDetailList, tag => {
            return !_.isEmpty(tag);
        })
    }
    
    return tempTagList;
}

const ShowTags = ({tagDetailList}) => {
    const [tagList, setTagList] = useState(prepareTagList(tagDetailList));

    useEffect(() => {
        setTagList(prepareTagList(tagDetailList));
    }, [tagDetailList]);

    return (
        <>
            <div className="flex flex-wrap">
                {tagList?.map((tag, index) => {
                    return <div key={`tag-${index}`}
                                className={`m-1 border border-gray-500 px-2 py-0 rounded flex justify-center`}>
                        {tag?.startText || tag}
                    </div>
                })}
            </div>
        </>
    )
}

export default ShowTags
